<div class="container">

  <header class="page-heading">
    <h1>Sukanya Samriddhi Yojana (SSY) Calculator</h1>
    <p>Calculate the maturity value of a Sukanya Samriddhi Yojana account for your girl child with this online SSY calculator.</p>
  </header>

  <div class="card mb-lg">
    <div class="section-title">Sukanya Samriddhi Yojana Details</div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('girlAge')">
        <label class="field-label" for="girlAge">Girl Child's Age (at account opening)</label>
        <div class="input-shell suffix">
          <input id="girlAge" type="number"
            [(ngModel)]="girlAge"
            [min]="C.girlAge.min" [max]="C.girlAge.max" step="1"
            (ngModelChange)="onFieldChange('girlAge')"
            (blur)="onFieldBlur('girlAge')"
            placeholder="e.g. 5"
            autocomplete="off"/>
          <span class="affix right">Yr</span>
        </div>
        <div class="field-hint">An SSY account can only be opened for a girl child below 10 years of age.</div>
        @if (hasError('girlAge')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('girlAge') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('yearlyDeposit')">
        <label class="field-label" for="yearlyDeposit">Yearly Deposit</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="yearlyDeposit" type="number"
            [(ngModel)]="yearlyDeposit"
            [min]="C.yearlyDeposit.min" [max]="C.yearlyDeposit.max" [step]="C.yearlyDeposit.step"
            (ngModelChange)="onFieldChange('yearlyDeposit')"
            (blur)="onFieldBlur('yearlyDeposit')"
            placeholder="e.g. 50,000"
            autocomplete="off"/>
        </div>
        <div class="field-hint">{{ C.yearlyDeposit.min | currency:'INR':'symbol':'1.0-0':'en-IN' }} – {{ C.yearlyDeposit.max | currency:'INR':'symbol':'1.0-0':'en-IN' }} per year, for the first {{ depositYears }} years</div>
        @if (hasError('yearlyDeposit')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('yearlyDeposit') }}
          </div>
        }
      </div>
    </div>

    <div class="field-group" [class.has-error]="hasError('annualRate')">
      <label class="field-label" for="annualRate">Interest Rate</label>
      <div class="input-shell suffix">
        <input id="annualRate" type="number"
          [(ngModel)]="annualRate"
          [min]="C.rate.min" [max]="C.rate.max" [step]="C.rate.step"
          (ngModelChange)="onFieldChange('annualRate')"
          (blur)="onFieldBlur('annualRate')"
          placeholder="e.g. 8.2"
          autocomplete="off"/>
        <span class="affix right">%</span>
      </div>
      <div class="field-hint">Current SSY rate is set by the government each quarter.</div>
      @if (hasError('annualRate')) {
        <div class="field-error">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {{ fieldError('annualRate') }}
        </div>
      }
    </div>

    <div class="action-row">
      <button type="button" class="btn btn-primary" (click)="calculate()" [class.btn-disabled]="showFormErrors && !isFormValid">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Calculate
      </button>
      @if (calculated) {
        <button type="button" class="btn btn-secondary" (click)="reset()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          Reset
        </button>
      }
      @if (showFormErrors && !isFormValid) {
        <span class="form-error-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Fix the errors above to calculate
        </span>
      }
    </div>
  </div>

  @if (calculated && result) {
    <div class="summary-grid mb-md">
      <div class="summary-card c-blue">
        <div class="sc-icon"></div>
        <div class="sc-label">Maturity Value</div>
        <div class="sc-value">{{ fmt.currency(result.maturityValue) }}</div>
        <div class="sc-sub">after {{ maturityYears }} years, at age {{ maturityAge }}</div>
      </div>
      <div class="summary-card c-green">
        <div class="sc-icon"></div>
        <div class="sc-label">Total Invested</div>
        <div class="sc-value">{{ fmt.currency(result.totalInvested) }}</div>
        <div class="sc-sub">{{ fmt.currency(yearlyDeposit) }}/yr for {{ depositYears }} years</div>
      </div>
      <div class="summary-card c-red">
        <div class="sc-icon"></div>
        <div class="sc-label">Interest Earned</div>
        <div class="sc-value">{{ fmt.currency(result.totalInterest) }}</div>
        <div class="sc-sub">@ {{ annualRate }}% p.a.</div>
      </div>
    </div>

    <div class="card charts-card mb-md">
      <div class="section-title">Visual Breakdown</div>
      <div class="charts-top-row">
        <div class="chart-panel">
          <div class="chart-panel-label">Invested vs Interest</div>
          <div class="chart-canvas-wrap chart-canvas-pie">
            <canvas #breakdownRef></canvas>
          </div>
        </div>
        <div class="chart-panel chart-panel-bar">
          <div class="chart-panel-label">Balance Growth</div>
          <div class="chart-canvas-wrap">
            <canvas #growthRef></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-md">
      <div class="section-title">Year-wise Growth</div>
      <div class="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th class="t-left">Year</th>
              <th class="t-balance">Opening Balance</th>
              <th>Deposit</th>
              <th class="t-interest">Interest</th>
              <th class="t-balance">Closing Balance</th>
            </tr>
          </thead>
          <tbody>
            @for (row of result.rows; track row.year) {
              <tr>
                <td class="t-left t-year">Year {{ row.year }}</td>
                <td class="t-balance">{{ fmt.currency(row.openingBalance) }}</td>
                <td>{{ row.deposit > 0 ? fmt.currency(row.deposit) : '—' }}</td>
                <td class="t-interest">{{ fmt.currency(row.interest) }}</td>
                <td class="t-balance">{{ fmt.currency(row.closingBalance) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>

<!-- ══ SEO CONTENT ══════════════════════════════════════════════════════ -->
<section class="container seo-content">
  <div class="card">
    <h2 class="section-title">How is SSY Maturity Value Calculated?</h2>
    <p>
      Sukanya Samriddhi Yojana (SSY) is a government savings scheme for a girl child, opened before
      she turns 10. You can deposit every year for the first 15 years from account opening; the
      balance then continues to earn interest, compounded annually, until the account matures
      21 years after it was opened.
    </p>
    <p class="emi-formula">Balance<sub>n</sub> = (Balance<sub>n&minus;1</sub> + Deposit) &times; (1 + Rate)</p>
    <p>
      For example, depositing &#8377;50,000 every year for 15 years at 8.2% grows to a maturity
      value of about &#8377;23.9 lakh by the time the account matures, of which &#8377;7.5 lakh is
      your own investment and the rest is interest earned.
    </p>

    <h2 class="section-title mt-sm">Frequently Asked Questions</h2>
    <div class="faq-item">
      <h3>When can I withdraw from an SSY account?</h3>
      <p>
        Partial withdrawal (up to 50%) is allowed once the girl turns 18 or completes 10th standard,
        for higher education expenses. The account can also be closed early for her marriage after
        she turns 18. Otherwise, it matures 21 years after opening.
      </p>
    </div>
    <div class="faq-item">
      <h3>Is SSY interest taxable?</h3>
      <p>
        No. SSY falls under the EEE (Exempt-Exempt-Exempt) tax category &mdash; contributions
        (up to &#8377;1,50,000 under Section 80C), interest earned, and the maturity amount are all
        tax-free under current Indian tax law.
      </p>
    </div>
    <div class="faq-item">
      <h3>How many SSY accounts can a family open?</h3>
      <p>
        One account per girl child, up to a maximum of two girl children per family (with an
        exception for twins or triplets born after the first girl child).
      </p>
    </div>
    <p class="learn-crosslink">
      Read more: <a routerLink="/learn/section-80c-ppf-vs-elss-vs-ssy">Section 80C explained: PPF vs ELSS vs SSY</a>
    </p>
  </div>
</section>
